<template>
  <div class="form-electronic-mail" id="form-electronic-mail" v-show="showComponent">
    <div class="fem-hd">
      <h3 class="fem-title">电子保函补充信息</h3>
      <span class="fem-arrow">
        <el-icon class="icon-date-close" @click="toggleShowAll">
          <ArrowUpBold v-if="showAll" />
          <ArrowDownBold v-else />
        </el-icon>
      </span>
    </div>
    <el-form ref="refForm" :model="formItems" label-width="110px" class="fem-bd">
      <el-row>
        <el-col v-for="(formItem, i) in formItems" :key="i" :span="i !== brIndex || i % 2 ? 12 : 24" v-show="!formItem.disabled || showAll">
          <el-form-item :label="formItem.name" :prop="`${i}.value`" :rules="rulesItem(formItem)" class="fem-label">
            <el-input v-model.trim="formItem.value" :disabled="formItem.disabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { config } from './config'
import { ArrowUpBold, ArrowDownBold } from "@element-plus/icons-vue";
import { mapState, mapActions, mapMutations } from "vuex";
import validator from "~@/tender-editor/src/js/validator";
import trafficUtils from '@/common/tender/traffic/utils'
export default {
  name: "BearElectronicMail",
  components: { ArrowUpBold, ArrowDownBold },
  data() {
    return {
      showAll: false,
      brIndex: 999
    };
  },
  computed: {
    ...mapState(["form", "baseInfo", "count", "commitAction", "sysCode", "actions", "isTraffic"]),
    ...mapState("electronicMail", ["formItems"]),
    allValid() {
      let { success, total } = this.count;
      return success === total;
    },
    showComponent() {
      return config.show(this.form, this.formItems, this.allValid, this.MARGIN_PAY_TYPE.split(','))
    },
    shouldInitForm() {
      return config.show(this.form, [0], this.allValid, this.MARGIN_PAY_TYPE.split(','))
    },
    MARGIN_PAY_TYPE() {
      const { t1871_MARGIN_SUBMIT_TYPE, t1873_MARGIN_SUBMIT_TYPE, t1913_MARGIN_SUBMIT_TYPE, t1911_MARGIN_SUBMIT_TYPE, t1957_MARGIN_SUBMIT_TYPE } = this.form
      return t1871_MARGIN_SUBMIT_TYPE || t1873_MARGIN_SUBMIT_TYPE || t1913_MARGIN_SUBMIT_TYPE || t1911_MARGIN_SUBMIT_TYPE || t1957_MARGIN_SUBMIT_TYPE || ''
    }
  },
  watch: {
    "actions"(val, oldVal) {
      if(this.isTraffic && val.length && !oldVal.length) {
        this.initFormItemsForTraffic()
      }
    },
    "form.REGION_CODE"(val, oldVal) {
      this.whenToInitForm(val, oldVal);
    },
    "form.MARGIN_PAY_TYPE"(val, oldVal) {
      this.whenToInitForm(val, oldVal);
    },
    allValid(val, oldVal) {
      if (val) {
        this.whenToInitForm(val, oldVal);
      }
    },
  },
  mounted() {
    if (!this.isTraffic) {
      this.initFormItems();
    }
    this.setVm(this);
  },
  methods: {
    ...mapActions("electronicMail", ["requestNoticeData", "pushNoticeData"]),
    ...mapMutations("electronicMail", ["setFormItems", "setVm", "setShow"]),
    whenToInitForm(val, oldVal) {
      clearTimeout(this.xtv)
      this.xtv = setTimeout(() => {
        let { allValid, shouldInitForm } = this
        let isChange = JSON.stringify(val) !== JSON.stringify(oldVal)
        if (shouldInitForm && allValid && isChange) {
          if (this.isTraffic) {
            this.initFormItemsForTraffic()
          } else {
            this.initFormItems()
          }
        }
      }, 100)
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
    rulesItem(item) {
      let { type } = item;
      let [t1, t2] = type.split("-");
      let rule = null;
      switch (t1) {
        case "int":
          rule = validator.numberValidWithDecimal(0);
          break;
        case "intOr/":
          rule = validator.numberValidWithDecimal(0, ["/"]);
          break;
        case "Number":
          if(t2 === '0') {
            rule = { pattern: /^\d+(\.\d+)?$/, message: '请输入数字' }
          } else {
            rule = validator.numberValidWithDecimal(t2 - 0); // 
          }
          break;
        case "societyCode":
          rule = validator.orgOrSociety({ Name: item.name });
      }
      if (rule) {
        rule.required = true;
        return [rule];
      } else {
        return [
          { required: true, message: `请输入${item.name}` },
          { max: item.maxLength - 0, message: `长度不超过${item.maxLength}` },
        ];
      }
    },
    initFormItems(call) {
      let { form, sysCode } = this;
      let supForm = {
        SYS_CODE: sysCode,
        BEIANDIQU_CODE: form.regionId,
        MARGIN_PAY_TYPE: form.MARGIN_PAY_TYPE,
        PROJECT_ID: form.foId,
      };
      let data = {
        ...form,
        ...supForm,
      };
      let ignoreKeys = [
        "bookingOptions",
        "CreatedByData",
        "FJGGZY_FILE_LIST",
        "UUM_ENTP_BASE_INFO",
        "NOTICE_CONTENT",
        "TENDER_FILE",
        "SPECIAL_CONTRACT_CONTENT",
      ];
      ignoreKeys.forEach((key) => {
        delete data[key];
      });
      let formData = {
        notice: 1,
        data: JSON.stringify(data),
      };
      this.requestNoticeData(formData)
        .then((formItems) => {
          formItems.sort((a, b) => {
            return a.disabled && !b.disalbed ? 1 : -1;
          });
          this.brIndex = formItems.findIndex((item) => item.disabled) - 1;
          
          this.setFormItems(formItems);
          call && call();
        })
        .catch((e) => {
          console.log(e)
          this.setFormItems([]);
        });
    },
    initFormItemsForTraffic(call) {
      const { form, baseInfo = {} } = this
      const data = trafficUtils.buildGuaranteeData(form, baseInfo)
      const formData = {
        notice: 1,
        data: JSON.stringify(data),
      };
      this.requestNoticeData(formData)
        .then((formItems) => {
          formItems.sort((a, b) => {
            return a.disabled && !b.disalbed ? 1 : -1;
          });
          this.brIndex = formItems.findIndex((item) => item.disabled) - 1;
          this.setFormItems(formItems);
          call && call();
        })
        .catch(() => {
          this.setFormItems([]);
        });
    },
    validForm(call) {
      if (this.showComponent) {
        this.$refs.refForm.validate((valid, invalidFields) => {
          console.log(valid, invalidFields);
          // if (!valid) {
          //   console.log(this.formItems[0].key);
          //   this.$refs.refForm.scrollToField(Object.keys(invalidFields)[0]);
          // }
          call && call(valid);
        });
      } else {
        call && call(true);
      }
    },
    submitForm(call, optionType) {
      let { form, isTraffic, baseInfo = {} } = this;
      let data = isTraffic ?  {
        formConfig: this.formItems,
        project_id: baseInfo.TENDER_PROJECT_CODE,
      } : {
        formConfig: this.formItems,
        project_id: form.foId,
      };
      this.pushNoticeData({
        optionType: optionType || 1,
        data: JSON.stringify(data),
      }).then((res) => {
        call && call();
      });
    },
    commit(call) {
      if (this.showComponent) {
        /*先保存电子保函表单中变化的数据*/
        this.submitForm(() => {
          /*获取由交易平台数据变化而变化的电子保函表单*/
          if (this.isTraffic) {
            this.initFormItemsForTraffic(() => {
              /*保存全部变化的表单*/
              this.submitForm(call, 1);
            });

          } else {
            this.initFormItems(() => {
              /*保存全部变化的表单*/
              this.submitForm(call, 1);
            });
          }

        }, 1);
      } else {
        call && call();
      }
    },
    sign(call) {
      if (this.showComponent) {
        this.submitForm(call, 2);
      } else {
        call && call();
      }
    },
    scrollIntoView() {
      this.$refs.refForm.$el.scrollIntoView({ behavior: "smooth" });
    },
    signMail(form, call) {
      config.sign(form, call)
    }
  },
};
</script>
<style lang="scss" scoped>
.form-electronic-mail {
  width: 900px;
  margin: 0 auto 15px;
  box-sizing: border-box;
  background: white;
  box-shadow: 0px 0px 5px 1px #aaabaf;
  border: 1px solid #20a0ff;
  .fem-hd {
    position: relative;
    text-align: center;
    color: white;
    background: #20a0ff;
    .fem-title {
      margin: 0;
      font: bold 20px/50px microsoft yahei;
    }
    .fem-arrow {
      position: absolute;
      z-index: 1;
      top: 0;
      right: 10px;
      font: bold 25px/50px microsoft yahei;
      cursor: pointer;
    }
  }
  .fem-bd {
    margin-top: 15px;
    padding: 30px;
    transition: all cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
}
</style>
<style lang="scss">
.form-electronic-mail {
  .fem-label {
    margin-left: 5px;
    .el-form-item__label {
      line-height: 20px;
    }
  }
}
</style>
